import { render, staticRenderFns } from "./AirwallexSavedCards.vue?vue&type=template&id=ddf3669a&scoped=true&"
import script from "./AirwallexSavedCards.vue?vue&type=script&lang=js&"
export * from "./AirwallexSavedCards.vue?vue&type=script&lang=js&"
import style0 from "./AirwallexSavedCards.vue?vue&type=style&index=0&id=ddf3669a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf3669a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
